module.exports = __webpack_public_path__ + "img/boton-tours.cb2ee010.jpg";